export default "__VITE_ASSET__Dc9jTXDN__"